var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsageRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.769941,
    y: 0.460859,
    width: 20.46,
    height: 20.46,
    rx: 10.23,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.769941,
    y: 0.460859,
    width: 20.46,
    height: 20.46,
    rx: 10.23,
    stroke: "#F90101",
    strokeWidth: 0.66
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_833_40650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5964 12.203H14.3668V10.4058C14.3668 10.3538 14.3242 10.3112 14.2722 10.3112H11.3399V9.17613H12.6169C12.7209 9.17613 12.8061 9.091 12.8061 8.98695V5.58176C12.8061 5.47771 12.7209 5.39258 12.6169 5.39258H9.2117C9.10765 5.39258 9.02252 5.47771 9.02252 5.58176V8.98695C9.02252 9.091 9.10765 9.17613 9.2117 9.17613H10.4886V10.3112H7.55639C7.50437 10.3112 7.4618 10.3538 7.4618 10.4058V12.203H6.23215C6.1281 12.203 6.04297 12.2881 6.04297 12.3922V15.7974C6.04297 15.9014 6.1281 15.9865 6.23215 15.9865H9.63735C9.74139 15.9865 9.82652 15.9014 9.82652 15.7974V12.3922C9.82652 12.2881 9.74139 12.203 9.63735 12.203H8.3131V11.1625H13.5155V12.203H12.1912C12.0872 12.203 12.0021 12.2881 12.0021 12.3922V15.7974C12.0021 15.9014 12.0872 15.9865 12.1912 15.9865H15.5964C15.7005 15.9865 15.7856 15.9014 15.7856 15.7974V12.3922C15.7856 12.2881 15.7005 12.203 15.5964 12.203ZM8.92793 13.1016V15.0879H6.94156V13.1016H8.92793ZM9.92111 8.27754V6.29117H11.9075V8.27754H9.92111ZM14.887 15.0879H12.9007V13.1016H14.887V15.0879Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_833_40650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.594,
    height: 10.594,
    fill: "white",
    transform: "translate(5.61719 5.39258)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageRed);
export default __webpack_public_path__ + "static/media/Usage-Red.176680e2f95d314fca84d66f2b1e5618.svg";
export { ForwardRef as ReactComponent };